import { SupportedLocale } from '@/types/supported-locale.type';

export const COUNTRY_FLAGS: Record<SupportedLocale, string> = {
  fr: 'https://flagcdn.com/fr.svg',
  en: 'https://flagcdn.com/gb.svg',
  es: 'https://flagcdn.com/es.svg',
  de: 'https://flagcdn.com/de.svg',
  it: 'https://flagcdn.com/it.svg',
};
